/**
 * @flow
 */
import React, { Component } from 'react'
import Header from './Layout/Header/index'
import Footer from './Layout/Footer'
import {Container, Row, Col} from 'reactstrap';
const FontAwesome = require('react-fontawesome')

const styles = {
  container: {
    height: '100vh',
  },
  fullHeight: {
    height: '100%'
  },
  centeredContainer: {
    flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
  }
}

export default class NoMatch extends Component {
  render () {
    return (
      <div style={styles.container}>
        <Header />
        <Container style={styles.fullHeight}>
          <Row style={styles.fullHeight}>
            <Col style={styles.centeredContainer}>
              <FontAwesome name='exclamation' style={{fontSize: '96px', color: '#CCCCCC'}} />
              <h1 style={{color: 'rgba(162, 162, 162, 1)'}}>{'Seite nicht gefunden'}</h1>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/NoMatch.js